import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import vw from 'src/styles/utils';
import media from 'src/styles/media';

import { QuestionnaireLabel } from 'src/styles/QuestionnaireLabel.styled';
// Example on how to pass props from another component:
// <MultiSelectCheckbox
//   data={questionnaireSelection.reasonForPurchase.options}
//   maxSelect={3} // if max select is not entered, it is 0. There are no limits.
//   title="Reason For Purchase"
//    required
// />;
// BEWARE OF THE TYPES!

// If the data is too abstract to sort like "2 weeks", "good". Then the component won't run the sort function.

export const MultiSelectCheckbox = (props) => {
  const {
    data,
    maxSelect,
    title,
    other,
    name,
    mustMax,
    otherText,
    abstract,
    // checkedSections,
    // setCheckedSections,
    required,
    validCheckboxSections,
    setValidCheckboxSections,
  } = props;

  const [activeSelectionCount, setActiveSelectionCount] = useState(0);
  const [otherSelected, setOtherSelected] = useState(false);
  const [checkedBoxArray, setCheckedBoxArray] = useState([]);
  const [isActivated, setIsActivated] = useState(false);
  // const [isValid, setIsValid] = useState(false);

  const sortedData = [...data].sort((a, b) =>
    a.value.toLowerCase().localeCompare(b.value.toLowerCase())
  );

  useEffect(() => {
    if (activeSelectionCount > 0 && required) {
      setIsActivated(true);
      // isValid(true);
      if (!validCheckboxSections.includes(name)) {
        if (mustMax && mustMax > 1 && mustMax === activeSelectionCount) {
          setValidCheckboxSections([...validCheckboxSections, name]);
        }

        if (!mustMax) {
          setValidCheckboxSections([...validCheckboxSections, name]);
        }
        // console.log(`${name} is added to valid array`);
        // console.log(name);
        // console.log(validCheckboxSections);
      }
    }

    if (activeSelectionCount === 0 && required) {
      // isValid(false);
      if (validCheckboxSections.includes(name)) {
        if (mustMax && mustMax !== activeSelectionCount) {
          setValidCheckboxSections(
            validCheckboxSections.filter((i) => i !== name)
          );
        }

        if (!mustMax) {
          setValidCheckboxSections(
            validCheckboxSections.filter((i) => i !== name)
          );
        }
        // console.log(`${name} is removed from invalid array`);
        // console.log(name);
        // console.log(validCheckboxSections);
      }
    }
  }, [activeSelectionCount]);

  return (
    <Root>
      <QuestionnaireLabel>{title}</QuestionnaireLabel>
      <CheckboxWrapper>
        {(abstract ? data : sortedData).map((item, index) => {
          if (!item.afterOther) {
            return (
              <Checkbox
                activeSelectionCount={activeSelectionCount}
                setActiveSelectionCount={setActiveSelectionCount}
                setOtherSelected={setOtherSelected}
                maxSelect={maxSelect}
                // itemContent={item.content ? item.content : item.value}
                itemContent={item.value}
                itemValue={item.value}
                name={name}
                key={index}
                title={title}
                required={required}
                // isValid={isValid}
                // setIsValid={setIsValid}
                // checkedSections={checkedSections}
                // setCheckedSections={setCheckedSections}
                checkedBoxArray={checkedBoxArray}
                setCheckedBoxArray={setCheckedBoxArray}
              />
            );
          }
        })}
        {other ? (
          <Checkbox
            activeSelectionCount={activeSelectionCount}
            setActiveSelectionCount={setActiveSelectionCount}
            maxSelect={maxSelect}
            name={name}
            title={title}
            required={required}
            itemContent={otherText || 'Other'}
            itemValue={otherText || 'Other'}
            otherSelected={otherSelected}
            setOtherSelected={setOtherSelected}
            otherText={otherText}
            // isValid={isValid}
            // setIsValid={setIsValid}
            // checkedSections={checkedSections}
            // setCheckedSections={setCheckedSections}
            checkedBoxArray={checkedBoxArray}
            setCheckedBoxArray={setCheckedBoxArray}
            dataOther
          />
        ) : null}
        {(abstract ? data : sortedData).map((item, index) => {
          if (item.afterOther) {
            return (
              <Checkbox
                activeSelectionCount={activeSelectionCount}
                setActiveSelectionCount={setActiveSelectionCount}
                setOtherSelected={setOtherSelected}
                maxSelect={maxSelect}
                // itemContent={item.content ? item.content : item.value}
                itemContent={item.value}
                itemValue={item.value}
                name={name}
                key={index}
                title={title}
                required={required}
                // isValid={isValid}
                // setIsValid={setIsValid}
                // checkedSections={checkedSections}
                // setCheckedSections={setCheckedSections}
                checkedBoxArray={checkedBoxArray}
                setCheckedBoxArray={setCheckedBoxArray}
              />
            );
          }
        })}
      </CheckboxWrapper>
      {mustMax > 1 && mustMax !== activeSelectionCount && isActivated ? (
        <ErrorText>
          Please select {mustMax - activeSelectionCount} more{' '}
          {mustMax - activeSelectionCount === 1 ? 'option' : 'options'}.
        </ErrorText>
      ) : null}
    </Root>
  );
};

const Checkbox = (props) => {
  const {
    setActiveSelectionCount,
    activeSelectionCount,
    itemContent,
    name,
    title,
    maxSelect,
    otherSelected,
    setOtherSelected,
    otherText,
    checkedBoxArray,
    setCheckedBoxArray,
    // checkedSections,
    // setCheckedSections,
    dataOther,
    // isValid,
    // setIsValid,
    required,
  } = props;

  const [isChecked, setIsChecked] = useState(false);
  const [otherInputValue, setOtherInputValue] = useState(null);

  const handleOtherChange = (e) => {
    if (!isChecked) {
      if (activeSelectionCount < maxSelect || maxSelect === 0) {
        setIsChecked(!isChecked);
        setActiveSelectionCount(activeSelectionCount + 1);
        setCheckedBoxArray([...checkedBoxArray, e.target.id]);

        if (e.target.dataset.title === 'other') {
          // console.log(e.target.name);
          setOtherSelected(!otherSelected);
        }
      }
    } else if (isChecked) {
      setIsChecked(!isChecked);
      setActiveSelectionCount(activeSelectionCount - 1);

      setCheckedBoxArray(
        checkedBoxArray.filter((checkedBox) => checkedBox !== e.target.id)
      );
      if (e.target.dataset.title === 'other') {
        setOtherSelected(!otherSelected);
        setOtherInputValue('');
      }
    }
  };

  const handleChange = (e) => {
    if (!isChecked) {
      if (activeSelectionCount < maxSelect || maxSelect === 0) {
        setIsChecked(!isChecked);
        setActiveSelectionCount(activeSelectionCount + 1);
        setCheckedBoxArray([...checkedBoxArray, e.target.id]);
      }
    } else if (isChecked) {
      setIsChecked(!isChecked);
      setActiveSelectionCount(activeSelectionCount - 1);

      setCheckedBoxArray(
        checkedBoxArray.filter((checkedBox) => checkedBox !== e.target.id)
      );
    }
  };

  // deal with the 1,2,3

  return (
    <StyledRoot>
      <StyledCheckbox
        type="checkbox"
        data-required={required}
        name={
          checkedBoxArray.includes(name + itemContent)
            ? `${name}-${checkedBoxArray.indexOf(name + itemContent) + 1}`
            : name
        }
        value={
          otherSelected
            ? otherInputValue === ''
              ? otherText || 'Other'
              : otherInputValue
            : itemContent
        }
        id={name + itemContent}
        data-title={dataOther ? 'other' : 'option'}
        data-question={title}
        data-id={name}
        data-priority={
          checkedBoxArray.includes(name + itemContent)
            ? checkedBoxArray.indexOf(name + itemContent) + 1
            : ''
        }
        onChange={
          itemContent === 'Other' || itemContent === otherText
            ? handleOtherChange
            : handleChange
        }
        checked={isChecked}
        styledCheckboxNumber={
          checkedBoxArray.includes(name + itemContent)
            ? checkedBoxArray.indexOf(name + itemContent) + 1
            : ''
        }
      />
      <label htmlFor={name + itemContent}>
        {itemContent === 'Other' || itemContent === otherText
          ? `${itemContent}:`
          : itemContent}
      </label>

      {/* Other input box shows up if the checkbox is other and checked */}
      {itemContent === 'Other' || itemContent === otherText ? (
        <input
          type="text"
          disabled={
            checkedBoxArray.includes(name + itemContent) ||
            checkedBoxArray.includes('Other')
              ? false
              : true
          }
          onChange={(e) => setOtherInputValue(e.target.value)}
          value={
            otherInputValue !== 'Other' || otherInputValue !== itemContent
              ? otherInputValue
              : ''
          }
          // value={otherInputValue || ""}
        />
      ) : null}
    </StyledRoot>
  );
};

// PROP TYPES

MultiSelectCheckbox.propTypes = {
  maxSelect: PropTypes.number,
  data: PropTypes.array,
  title: PropTypes.string,
  other: PropTypes.bool,
  otherText: PropTypes.string,
  name: PropTypes.string,
};

MultiSelectCheckbox.defaultProps = {
  maxSelect: 0,
};

Checkbox.propTypes = {
  activeSelectionCount: PropTypes.number,
  maxSelect: PropTypes.number,
  itemContent: PropTypes.string,
  itemValue: PropTypes.string,
  name: PropTypes.string,
  otherSelected: PropTypes.bool,
  otherText: PropTypes.string,
  checkedBoxArray: PropTypes.array,
};

// STYLED COMPONENTS
const Root = styled.section`
  width: 100%;
  &.error p {
    color: red;
    &:after {
      content: ' This field is required.';
      /* white-space: pre; */
      color: black;
      font-weight: light;
      font-style: italic;
      text-transform: capitalize;
    }
  }
`;

const CheckboxWrapper = styled.div`
  ${vw('margin-top', 10, 0)}
  ${vw('margin-bottom', 60)}
  @media ${media.desktop} {
    /* grid-template-columns: 1fr 1fr; */
    column-count: 2;
  }
`;

const StyledRoot = styled.div`
  display: inline-block;
  width: 100%;
  height: 100%;

  /* flex-direction: row;
  justify-content: left;
  align-items: top; */
  /* ${vw('line-height', 24, 24)} */
  ${vw('font-size', 13, 16)}
  /* ${vw('padding-bottom', 10, 10)} */


  label {
    display: inline-block;
    margin-top: 20px;
    ${vw('margin-right', 6, 6)};
  }

  label:hover {
    cursor: pointer;
  }

  input {
    vertical-align: middle;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    color: #747474;
    ${vw('height', 30)}
    ${vw('font-size', 13, 15)}
    /* ${vw('line-height', 10, 16)} */
    ${vw('letter-spacing', 0.06)}
    /* ${vw('padding-left', 3, 5)} */
  }

  input:disabled {
    opacity: 0.5;
    background: #e1e1e1;
  }
`;
const StyledCheckbox = styled.input`
  top: -2px;
  &[type='checkbox'] {
    /* display: flex; */
    -webkit-appearance: initial;
    appearance: initial;
    ${vw('width', 20, 25)}
    ${vw('height', 21, 25)}
    ${vw('border-radius', 5)}

    border: none;
    background: #fff;
    position: relative;
    border: solid 1px #de5647;
    ${vw('margin-right', 10)};
    /* ${vw('margin-bottom', 15)} */
  }
  &[type='checkbox']:hover {
    cursor: pointer;
  }
  &[type='checkbox']:checked {
    background: #de5647;
    border: none;
  }
  &[type='checkbox']:checked:after {
    content: '${(props) => props.styledCheckboxNumber}';
    color: #fff;
    ${vw('font-size', 14, 15)}
    font-weight:bold;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ErrorText = styled.p`
  color: red !important;
  ${vw('margin-top', -30, -30, -30)}
  ${vw('padding-bottom', 30, 30, 30)}
`;
